var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('iframe',{attrs:{"width":"100%","height":"100%","src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }